// React requires
import React, {FC} from "react";
import {routeTransitions, routeVariants} from "../../app/config/route-transitions";
import {Container} from "react-grid-system";
import {motion} from "framer-motion";
import styled from "styled-components";

const NotFound: FC = () => {
    return (
        <motion.div
            initial="out"
            animate="in"
            exit="out"
            variants={routeVariants}
            transition={routeTransitions}
        >
            <SCNotFound>
                <Container>
                    <h1>Page not found!</h1>
                </Container>
            </SCNotFound>
        </motion.div>
    )
}

const SCNotFound = styled.div`
    padding-top: 110px;
    position: relative;
    
    h1{
      text-align: center;
    }
`;

export default NotFound;
